export interface ConflictResult {
  templates?: TemplateConflictInfo[]; // Optional array of TemplateConflictInfo
  assets?: AssetConflictInfo[]; // Optional array of AssetConflictInfo
}

export interface TemplateConflictInfo {
  current: Template;
  incoming: Template;
  conflicts: Record<TemplateConflictsEnum, TemplateResolutionEnum | null>;
}

export interface AssetConflictInfo {
  current: Asset;
  incoming: Asset;
  conflicts: Record<AssetConflictsEnum, AssetResolutionEnum | null>;
}

// Supporting Enums
export enum TemplateConflictsEnum {
  SOURCE_MISMATCH = 'SOURCE_MISMATCH',
  SCENE_DATA_MISMATCH = 'SCENE_DATA_MISMATCH',
}

export enum AssetConflictsEnum {
  NAME_MISMATCH = 'NAME_MISMATCH',
}

export enum TemplateResolutionEnum {
  KEEP_INCOMING = 'KEEP_INCOMING',
  KEEP_CURRENT = 'KEEP_CURRENT',
  CREATE_PRESET = 'CREATE_PRESET',
}

export enum AssetResolutionEnum {
  KEEP_INCOMING = 'KEEP_INCOMING',
  KEEP_CURRENT = 'KEEP_CURRENT',
}

interface Template {
  id?: number; // Optional
  uid?: string; // Optional
  description: string;
  name: string;
  multi: boolean;
  display_name: string;
  scene_data: Record<string, any>;
  hidden: boolean;
  timestamp: number;
  icon: string;
  src_file: string;
  src_scene_data: Record<string, any>;
  files: string[] | null; // Array or null
  thumbnail: string | null; // Nullable
  status: number | null; // Nullable
  conditions: Record<string, any>;
  default_triggers: any[];
  color: string | null; // Nullable
  dynamic_preload: boolean;
  revision: number;
  tags?: string[]; // Optional
  default_template: boolean;
  extra_info: Record<string, any>;
}

interface Asset {
  uid: string;
  name: string;
  preview_static_small: string | null; // Nullable
  preview_static_medium: string | null; // Nullable
  preview_motion_small: string | null; // Nullable
  preview_motion_medium: string | null; // Nullable
  preview_static_wide: string | null; // Nullable
  ready: boolean;
  info: Record<string, any>;
  asset_type: string;
  value: string;
  deleted: boolean;
  ingest_src: string | null; // Nullable
  timestamp: number;
  expire_datetime: string | null; // Nullable
  deleted_timestamp: number | null; // Nullable
  revision: number;
  revision_refs: string[]; // Array
  custom: boolean;
  protection_level: number;
  extra_info: Record<string, any>;
}
